/*
  Seal — the site's signature mark. Reused at three sizes:
  hero (large, animated on load), section eyebrows (tiny),
  and card corners (small). Pure SVG, currentColor, no raster asset.
*/
const Seal = ({ size = 48, className = "" }) => (
  <span className={`seal ${className}`} style={{ width: size, height: size }}>
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Tapaswe seal"
    >
      <circle cx="50" cy="50" r="46" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="50" cy="50" r="37" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.55" />
      {Array.from({ length: 24 }).map((_, i) => {
        const angle = (i * 360) / 24;
        const rad = (angle * Math.PI) / 180;
        const r1 = 46, r2 = 41;
        const x1 = 50 + r1 * Math.cos(rad);
        const y1 = 50 + r1 * Math.sin(rad);
        const x2 = 50 + r2 * Math.cos(rad);
        const y2 = 50 + r2 * Math.sin(rad);
        return (
          <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="currentColor" strokeWidth="1" opacity="0.6" />
        );
      })}
      <path d="M 33 50 L 45 62 L 68 37" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </span>
);

export default Seal;
